export default "__VITE_ASSET__CsLLgkCS__"